<style>
.notification {
  margin-bottom: 1px;
  cursor: pointer;
}

.notif-info {
  margin-left: 16px;
  margin-right: 10px;
  width: auto;
}

.notif-image {
  display: flex;
  align-items: center;
  position: relative;
}
.notif-image > .notif-type {
  position: absolute;
  bottom: 4px;
  right: -8px;
}

.notification-template .ivu-card-body {
  display: flex;
  justify-content: baseline;
}

.notif-info > .notif-info-date {
  color: #999;
  margin-top: 5px;
}

.extra-large {
  width: 56px;
  height: 56px;
  line-height: 56px;
  border-radius: 28px;
}

.notif-a {
  text-decoration: none;
  color: inherit;
  display: flex;
}

.notif-a:hover {
  text-decoration: none;
  color: inherit;
}
</style>
<template>
  <app-layout class="notification-template">
    <NotificationModal
      @accept="acceptCareTeam"
      @reject="rejectCareTeam"
      @close="closeNotificationModal()"
      :isShow="showNotificationModal"
    />

    <Row type="flex" justify="center">
      <Col :span="24">
        <div v-if="isLoading" style="padding:10px 0" align="center">
          <p align="center" style="margin-top:5px">
            <i class="fa fa-spin fa-spinner" /> Loading...
          </p>
        </div>
        <span v-else>
          <div v-if="notifications.length < 1" align="center" style="padding:10px">
            <span style="color:gray">No new notifications</span>
          </div>
          <div v-else v-for="notification in notifications" :key="notification.id">
            <Card
              shadow
              class="notification"
              :style="{ backgroundColor: setToBool(notification.is_new) ? '#f1f1f1' : '#fff'}"
            >
              <a class="notif-a" @click="viewNotification(notification)">
                <div class="notif-image">
                  <Avatar :src="notification.avatar" size="large" class="extra-large" />
                  <Avatar
                    :icon="getIcon(notification.type)"
                    size="small"
                    class="notif-type"
                    style="background: #009688;"
                  />
                </div>
                <div class="notif-info">
                  <span>
                    <p
                      v-if="notification.type == 'private_journal_invite'"
                      class="multiline-ellipsis"
                    >You have been invited to join {{notification.more_data.from_uname}}'s care team.</p>
                    <p
                      v-else
                      class="multiline-ellipsis"
                    >{{ notification.message || "Notification undefined" }}</p>
                  </span>
                  <p class="notif-info-date">
                    <timeago :since="notification.date_notified" />
                  </p>
                </div>
              </a>
            </Card>
            <!-- <Card shadow class="notification" v-else-if="notification.type === 'careplan_item_liked'">
                <a class="notif-a" @click="viewNotification(notification)" >
                  <div class="notif-image">
                    <Avatar :src="notification.user.avatar" size="large" class="extra-large"/>
                    <Avatar icon="thumbsup" size="small" class="notif-type" style="background: rgb(45, 140, 240);"/>
                  </div>
                  <div class="notif-info">
                    <p class="multiline-ellipsis"><b>{{ notification.user.display_name }}</b> liked on post in
                    <b>{{ notification.activity.content }}</b>
                    <p class="notif-info-date"> <timeago :since="notification.created_at"/></p>
                  </div>
                </a>
            </Card>-->
          </div>
          <Button
            v-if="hasNextLink"
            style="width:50%;display:flex;margin: 5px auto;justify-content:center;backgroundColor:white"
            @click="loadMore"
            default
            :loading="isLoadingMore"
          >
            <span v-if="!isLoadingMore" style="color:#2d8cf0">Load More</span>
            <span v-else>Loading...</span>
          </Button>
        </span>
        <!-- <div>
          <Card shadow class="notification">
             <div class="notif-image">
              <Avatar src="https://i.loli.net/2017/08/21/599a521472424.jpg" size="large" class="extra-large"/>
              <Avatar icon="ios-people" size="small" class="notif-type" style="background: #29B6F6;"/>
             </div>
             <div class="notif-info">
               <p class="multiline-ellipsis"><b>John Doe</b> invited you to join <b>Davao Developers</b></p>
               <p class="notif-info-date">June 2, 2018</p>
             </div>
          </Card>

          <Card shadow class="notification">
             <div class="notif-image">
              <Avatar src="https://d3iw72m71ie81c.cloudfront.net/male-47.jpg" size="large" class="extra-large" />
               <Avatar icon="heart" size="small" class="notif-type" style="background: #EC407A;"/>
             </div>
             <div class="notif-info">
               <p class="multiline-ellipsis"><b>Marl Doe</b> like your post in <b>Mobile Devs</b> "Have a nice day every one!"</p>
               <p class="notif-info-date">June 2, 2018</p>
             </div>
          </Card>

          <Card shadow class="notification">
             <div class="notif-image">
              <Avatar src="https://d3iw72m71ie81c.cloudfront.net/male-47.jpg" size="large" class="extra-large" />
               <Avatar icon="heart" size="small" class="notif-type" style="background: #EC407A;"/>
             </div>
             <div class="notif-info">
               <p class="multiline-ellipsis"><b>Marl Doe</b> like your post "For beautiful eyes, look for the good in others; for beautiful lips, speak only words of kindness; and for poise, walk with the knowledge that you are never alone."</p>
               <p class="notif-info-date">June 2, 2018</p>
             </div>
          </Card>

          <Card shadow class="notification">
             <div class="notif-image">
              <Avatar src="https://thumbs.dreamstime.com/b/automotive-car-logo-design-abstract-sports-vehicle-silhouette-icon-isolated-light-grey-background-vector-illustration-87351691.jpg" size="large" class="extra-large" />
               <Avatar icon="checkmark-round" size="small" class="notif-type" style="background: #66BB6A;"/>
             </div>
             <div class="notif-info">
               <p class="multiline-ellipsis">Your post in <b>Autostyle</b> has been approved.</p>
               <p class="notif-info-date">June 2, 2018</p>
             </div>
          </Card>

            <Card shadow class="notification">
              <div class="notif-image">
                <Avatar src="https://pbs.twimg.com/profile_images/893294194093150211/lkKxiqoS.jpg" size="large" class="extra-large" />
                <Avatar icon="person-stalker" size="small" class="notif-type" style="background: #5C6BC0;"/>
              </div>
              <div class="notif-info">
                <p class="multiline-ellipsis"><b>Cal Doe</b> added you as a staff in <b>Awesome Developers</b></p>
                <p class="notif-info-date">June 2, 2018</p>
              </div>
            </Card>

            <Card shadow class="notification">
             <div class="notif-image">
              <Avatar src="https://i.loli.net/2017/08/21/599a521472424.jpg" size="large" class="extra-large"/>
              <Avatar icon="chatboxes" size="small" class="notif-type" style="background: #009688;"/>
             </div>
             <div class="notif-info">
               <p class="multiline-ellipsis"><b>John Doe</b> commented on your post in <b>Awesome VueJs</b></p>
               <p class="notif-info-date">June 2, 2018</p>
             </div>
          </Card>
        </div>-->
      </Col>
    </Row>
  </app-layout>
</template>

<script>
import Axios from "axios";
import * as API from "@/endpoints";
import _ from "lodash";
import { Message } from "iview";
import WindowScrollEvent from "vue-scroll-event/mixins/WindowOnScroll";
import NotificationModal from "@/components/NotificationModal";

export default {
  name: "NotificationComponent",
  mixins: [WindowScrollEvent],
  components: { NotificationModal },
  data() {
    return {
      isLoadingMore: false
    };
  },
  computed: {
    isLoading() {
      return this.$store.state.notification.isLoading;
    },
    notifications() {
      return this.$store.state.notification.data;
      // .filter((notification) => {
      //   return (notification.avatar && notification.message)
      // })
    },
    showNotificationModal: {
      get() {
        return this.$store.state.notification.modal.show;
      },
      set(v) {
        this.$store.commit("notification/setShowModal", v);
      }
    },
    hasNextLink() {
      return this.$store.state.notification.next_link;
    },
    profileInfo() {
      return this.$store.state.user.info;
    }
  },
  mounted() {
    this.$store.dispatch('notification/getNotifications', 1)
      .then(res => {
        this.$store.dispatch('notification/updateLastViewedState')
        this.$store.commit("doBeep", false, {root: true})
      })
  },
  destroyed() {
    this.showNotificationModal = false;
  },
  methods: {
    setToBool(v) {
      return parseInt(v);
    },
    closeNotificationModal() {
      this.showNotificationModal = false;
      // this.$store.commit('notification/setNotification', null)
    },
    acceptCareTeam(notification) {
      console.log(notification);

      if (notification.more_data.is_accepted) {
        Message.error(
          `You have already accepted this ${
            notification.type == "private_journal_invite"
              ? "invitation"
              : "request"
          }`
        );
        this.closeNotificationModal();
        return false;
      }

      if (notification.type == "private_journal_invite") {
        this.$store
          .dispatch("careteam/acceptCareTeamPrescribe", {
            id: notification.more_data.invitation_id
          })
          .then(res => {
            this.closeNotificationModal();
            this.$router.push(`/profile/${notification.more_data.from_uid}`);
          });
      } else if (notification.type == "careteam_request") {
        this.$store
          .dispatch("careteam/acceptCareTeamRequest", {
            id: notification.more_data.invitation_id
          })
          .then(res => {
            this.closeNotificationModal();
            this.$router.push(`/profile/${this.profileInfo.id}?tab=team`);
          });
      }
    },
    rejectCareTeam(notification) {
      console.log(notification);

      if (notification.more_data.is_accepted) {
        Message.error(
          `You have already accepted this ${
            notification.type == "private_journal_invite"
              ? "invitation"
              : "request"
          }`
        );
        this.closeNotificationModal();
        return false;
      }

      this.$store.dispatch("careteam/rejectCareTeamInvite", {
        id: notification.more_data.invitation_id
      });
      this.closeNotificationModal();
    },
    getIcon(type) {
      switch (type) {
        case "activity_comment":
        case "careplan_item_comment":
          return "chatboxes";
          break;
        case "activity_like":
        case "careplan_item_like":
          return "thumbsup";
          break;
        case "group_update":
          return "document-text";
          break;
        case "group_join":
        case "group_invite":
        case "private_journal_invite":
        case "careteam_request":
          return "person-add";
          break;
        default:
          return "information";
          break;
      }
    },
    viewNotification(notification) {
      console.log("viewNotification...", notification);

      this.$store.commit("notification/setNotificationNewStatus", notification);

      let type = _.get(notification, "type")
        ? _.get(notification, "type")
        : _.get(notification, "component_action");

      switch (type) {
        case "activity_comment": // comment reply
        case "careplan_item_comment": // comment on a group post, commented on a followed post
          this.$router.push("/feed/" + notification.more_data.post_id + "?show_comment=true");
          break;
        case "activity_like":
        case "careplan_item_like":
          this.$router.push("/feed/" + notification.more_data.post_id);
          break;
        case "group_join":
        case "group_update":
        case "group_invite":
          BroadcastEvent.$emit("onGroupInvitation", {
            show: true,
            invitation_id: notification.more_data.invitation_id
          });
          // return
          // if(_.get(notification, "item_id"))
          //   this.$router.push('/resources/' + notification.item_id)
          // else
          //   this.$Message({
          //     closable: true,
          //     durationInSec: 3,
          //     title: { content: "Error" },
          //     icon: "alert",
          //     message: { content: "An error has occurred" }
          //   });
          break;
        case "private_journal_invite":
          this.$store.commit("notification/setNotification", notification);
          this.showNotificationModal = true;
          break;
        case "careteam_request":
          this.$store.commit("notification/setNotification", notification);
          this.showNotificationModal = true;
          break;
        case "careteam_update":
          if (notification.more_data.item_type == "journal")
            this.$router.push(`/profile/${this.profileInfo.id}?tab=timeline`);
          else this.$router.push(`/profile/${this.profileInfo.id}?tab=team`);
          break;
        case "group_assign":
          this.$router.push(`/resources/${notification.item_id}`);
          break;
        case "admin_alert":
          this.$router.push(`/feed/${notification.item_id}`);
          break;
        default:
          // TODO:
          break;
      }

      let payload = {
        is_new: 0,
        notification,
        notification_ids: [notification.id]
      };

      this.$store.dispatch("notification/updateViewedNotification", payload);
    },
    loadMore() {
      if (this.$store.state.notification.next_link) {
        this.isLoadingMore = true;
        this.$store.dispatch("notification/getNotifications").then(
          res => {
            this.isLoadingMore = false;
          },
          err => {
            this.isLoadingMore = false;
          }
        );
      }
    }
    // onWindowScrolledBottom () {
    //   if (this.$store.state.notification.next_link)
    //     this.$store.dispatch('notification/getNotifications')
    // }
  }
};
</script>-
